import {
    Button,
    Grid,
    Step, StepLabel,
    Stepper,
    styled
} from '@mui/material';
import { CustomAutocomplete } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomAutocomplete';
import { CustomCheckbox, CustomCheckboxGroup } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomGrouping';
import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraCaepf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCaepf';
import RegraCep from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCep';
import RegraCno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCno';
import RegraCnpj from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCnpj';
import RegraComprimentoMinimo from 'esocial.web.react.lib/cjs/components/form/Validation/RegraComprimentoMinimo';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraExpressaoRegular from 'esocial.web.react.lib/cjs/components/form/Validation/RegraExpressaoRegular';
import RegraHoraMinuto from 'esocial.web.react.lib/cjs/components/form/Validation/RegraHoraMinuto';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepRadioGroup } from 'esocial.web.react.lib/cjs/components/form/Vep/VepRadioGroup';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { VepTimePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTimePicker';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { limparMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { Mascara, TipoInscricao } from 'esocial.web.react.lib/cjs/utils/enums';
import { getStringValue, isUndefinedOrNull, obterMascaraPorTipoInscricao, obterObjetoTodosComponentesTocados, obterOpcaoAutocompletePorValorVep, rolarVisualizacaoAteElemento, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const BackButton = styled(Button)(({ theme }) => ({
    marginRight: theme.spacing(1)
}));

const StepButtonsBox = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: "flex",
    justifyContent: "space-between"
}));

const CnpjAlfanumerico = styled(VepTextField)(() => ({
    '& input': {
        fontFamily: 'monospace'
    }
}));

// 20/07/2022
const dtAcid_validacao_hrsTrabAntesAcid = new Date(2022, 6, 20);

// 16/01/2023
const dtAcid_validacao_ultDiaTrab = new Date(2023, 0, 16);

// 26/01/2022
const dtAcid_validacao_hrAcid = new Date(2022, 0, 26);

function CatRegistro({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    // Hook personalizado para requisições ao servidor
    const { get, post } = useRequisicaoControlada();

    //Para o Stepper
    const steps = ['Dados do acidente de trabalho', 'Local do acidente', 'Parte atingida / Agente causador', 'Atestado médico'];

    const handleNext = (e) => {
        if (activeStep === 3) {
            handleSubmit(e);
        } else {
            switch (activeStep) {
                case 0:
                    setComponenteTocadoFormularioStep1(obterObjetoTodosComponentesTocados(componenteTocadoFormularioStep1));
                    break;
                case 1:
                    setComponenteTocadoFormularioStep2(obterObjetoTodosComponentesTocados(componenteTocadoFormularioStep2));
                    break;
                case 2:
                    setComponenteTocadoFormularioStep3(obterObjetoTodosComponentesTocados(componenteTocadoFormularioStep3));
                    break;
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado('proximo');
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    function getStepperButtons(visualizacao) {
        return (
            <StepButtonsBox>
                <Button color="secondary" size="medium" onClick={() => navigate(-1)}>
                    {!visualizacao ? 'Cancelar' : 'Voltar'}
                </Button>

                <div>
                    <BackButton
                        variant="outlined"
                        color="primary"
                        disabled={activeStep < 1}
                        onClick={handleBack}
                    >
                        Anterior
                    </BackButton>

                    <Display show={activeStep !== steps.length - 1}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handleNext}>
                            Próximo
                        </Button>
                    </Display>

                    <Display show={!visualizacao && activeStep === steps.length - 1}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNext}
                        >
                            Salvar
                        </Button>
                    </Display>
                </div>
            </StepButtonsBox >);
    }

    function handleChangeTipoCat(e) {
        // Gerência básica do valor do tipoCat
        // Atribuição do valor padrão ao campo houveObito
        setModelo({
            ...modelo,
            tipoCat: { ...modelo.tipoCat, valor: e.target.value },
            catOrigem: { ...modelo.catOrigem, valor: (e.target.value == 2 || e.target.value == 3) ? modelo.catOrigem.valor : '' },
            houveObito: { ...modelo.houveObito, valor: e.target.value == 2 ? 'N' : (e.target.value == 3 ? 'S' : modelo.houveObito.valor) },
            atestadoMedico: {
                ...modelo.atestadoMedico, houveAfastamento: { ...modelo.atestadoMedico.houveAfastamento, valor: e.target.value == 3 ? 'N' : modelo.atestadoMedico.houveAfastamento.valor }
            }
        });
    }

    async function obterFonteDadosAutocompleteAgenteCausador(dataAcidente, tipoAcidente) {
        let fonteDadosAutocompleteAgenteCausador = [];

        await get(`sst/cat/obterFonteDadosAutocompleteAgenteCausador/${dataAcidente}/${tipoAcidente}`, (conteudoResposta) => { fonteDadosAutocompleteAgenteCausador = conteudoResposta; });

        return !isUndefinedOrNull(fonteDadosAutocompleteAgenteCausador) && Array.isArray(fonteDadosAutocompleteAgenteCausador) ? fonteDadosAutocompleteAgenteCausador : [];
    }

    async function handleChangeTipoAcidente(e) {
        // Gerência básica do valor do tipoAcidente
        // Limpeza condicional dos campos horaAcidente e horasTrabalhadasAntesAcidente
        let limparCampoHoraAcidente = true;
        let limparCampoHorasTrabalhadasAntesAcidente = true;

        // Com tratamento de exceção pois a data do acidente pode não ser válida
        try {
            if (e.target.value == 1 || (e.target.value == 3 && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrAcid)) {
                limparCampoHoraAcidente = false;
            }

            if (e.target.value == 1 || (e.target.value == 3 && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrsTrabAntesAcid)) {
                limparCampoHorasTrabalhadasAntesAcidente = false;
            }
        } catch (e) {
            // Nada a fazer
        }

        // Buscar a fonte de dados para o agente causador segundo a nova regra (v1.2)
        //Se dtAcid >= [2024-01-22] e se tpAcid = [1, 3], deve ser um código válido e existente na Tabela 14.
        //Se dtAcid < [2024-01 - 22] ou se tpAcid = [2], deve ser um código válido e existente na Tabela 14 ou na Tabela 15
        let fonteDadosAutocompleteAgenteCausador = [];
        const dataAcidente = new Date(modelo.dataAcidente.valor);

        if (!isNaN(dataAcidente) && dataAcidente.getFullYear() >= 1900) {
            fonteDadosAutocompleteAgenteCausador = await obterFonteDadosAutocompleteAgenteCausador(modelo.dataAcidente.valor, e.target.value);
        }

        // Anular o valor do agente causador caso não esteja presente na fonte de dados recuperada
        let valorAgenteCausador = modelo.agenteCausador.valor;

        if (!isUndefinedOrNull(valorAgenteCausador)
            && isUndefinedOrNull(fonteDadosAutocompleteAgenteCausador.find(x => x.valor === valorAgenteCausador))) {
            valorAgenteCausador = 0;
        }

        setModelo({
            ...modelo,
            tipoAcidente: { ...modelo.tipoAcidente, valor: e.target.value },
            horaAcidente: { ...modelo.horaAcidente, valor: !limparCampoHoraAcidente ? modelo.horaAcidente.valor : null },
            horasTrabalhadasAntesAcidente: { ...modelo.horasTrabalhadasAntesAcidente, valor: !limparCampoHorasTrabalhadasAntesAcidente ? modelo.horasTrabalhadasAntesAcidente.valor : '' },
            agenteCausador: {
                ...modelo.agenteCausador,
                valor: valorAgenteCausador,
                fonteDadosAutocomplete: fonteDadosAutocompleteAgenteCausador
            }
        });
    }

    const handleChangeDataAcidente = async (date) => {
        let limparCampoHoraAcidente = true;
        let limparCampoHorasTrabalhadasAntesAcidente = true;

        // Com tratamento de exceção pois a data do acidente pode não ser válida
        try {
            if (modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && new Date(date) >= dtAcid_validacao_hrAcid)) {
                limparCampoHoraAcidente = false;
            }

            if (modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && new Date(date) >= dtAcid_validacao_hrsTrabAntesAcid)) {
                limparCampoHorasTrabalhadasAntesAcidente = false;
            }
        } catch (e) {
            // Nada a fazer
        }

        // Buscar a fonte de dados para o agente causador segundo a nova regra (v1.2)
        //Se dtAcid >= [2024-01-22] e se tpAcid = [1, 3], deve ser um código válido e existente na Tabela 14.
        //Se dtAcid < [2024-01 - 22] ou se tpAcid = [2], deve ser um código válido e existente na Tabela 14 ou na Tabela 15
        let fonteDadosAutocompleteAgenteCausador = [];

        if (!isNaN(date) && date.getFullYear() >= 1900) {
            fonteDadosAutocompleteAgenteCausador = await obterFonteDadosAutocompleteAgenteCausador(date.toISOString(), modelo.tipoAcidente.valor);
        }

        // Anular o valor do agente causador caso não esteja presente na fonte de dados recuperada
        let valorAgenteCausador = modelo.agenteCausador.valor;

        if (!isUndefinedOrNull(valorAgenteCausador)
            && isUndefinedOrNull(fonteDadosAutocompleteAgenteCausador.find(x => x.valor === valorAgenteCausador))) {
            valorAgenteCausador = 0;
        }

        setModelo({
            ...modelo,
            dataAcidente: { ...modelo.dataAcidente, valor: date },
            horaAcidente: { ...modelo.horaAcidente, valor: !limparCampoHoraAcidente ? modelo.horaAcidente.valor : null },
            horasTrabalhadasAntesAcidente: { ...modelo.horasTrabalhadasAntesAcidente, valor: !limparCampoHorasTrabalhadasAntesAcidente ? modelo.horasTrabalhadasAntesAcidente.valor : '' },
            agenteCausador: {
                ...modelo.agenteCausador,
                valor: valorAgenteCausador,
                fonteDadosAutocomplete: fonteDadosAutocompleteAgenteCausador
            }
        });
    }

    function handleChangeHouveObito(e) {
        setModelo({
            ...modelo,
            houveObito: { ...modelo.houveObito, valor: e.target.value },
            dataObito: { ...modelo.dataObito, valor: e.target.value == 'S' ? modelo.dataObito.valor : null },
            atestadoMedico: {
                ...modelo.atestadoMedico, houveAfastamento: { ...modelo.atestadoMedico.houveAfastamento, valor: e.target.value == 'S' ? 'N' : modelo.atestadoMedico.houveAfastamento.valor }
            }
        });
    }

    function handleChangeTipoLocalAcidente(e) {
        const houveMudancaTipoEmbarcacaoParaOutrosTipos =
            getStringValue(modelo.localAcidente.tipoLocalAcidente.valor) === '6';

        let valorTipoLogradouro = e.target.value != 6 ? modelo.localAcidente.tipoLogradouro.valor : 'O';
        let valorNomeLogradouro = e.target.value != 6 ? modelo.localAcidente.nomeLogradouro.valor : 'Embarcação';
        let valorNumeroLogradouro = e.target.value != 6 ? modelo.localAcidente.numeroLogradouro.valor : 'S/N';

        if (houveMudancaTipoEmbarcacaoParaOutrosTipos) {
            valorTipoLogradouro = valorNomeLogradouro = valorNumeroLogradouro = '';
        }

        setModelo({
            ...modelo,
            localAcidente: {
                ...modelo.localAcidente,
                tipoLocalAcidente: { ...modelo.localAcidente.tipoLocalAcidente, valor: e.target.value },
                cep: { ...modelo.localAcidente.cep, valor: e.target.value != 2 && e.target.value != 6 ? modelo.localAcidente.cep.valor : '' },
                tipoLogradouro: { ...modelo.localAcidente.tipoLogradouro, valor: valorTipoLogradouro },
                nomeLogradouro: { ...modelo.localAcidente.nomeLogradouro, valor: valorNomeLogradouro },
                numeroLogradouro: { ...modelo.localAcidente.numeroLogradouro, valor: valorNumeroLogradouro },
                complemento: { ...modelo.localAcidente.complemento, valor: e.target.value != 6 ? modelo.localAcidente.complemento.valor : '' },
                bairro: { ...modelo.localAcidente.bairro, valor: e.target.value != 6 ? modelo.localAcidente.bairro.valor : '' },
                municipio: { ...modelo.localAcidente.municipio, valor: e.target.value != 2 && e.target.value != 6 ? modelo.localAcidente.cep.municipio : '' },
                uf: { ...modelo.localAcidente.uf, valor: e.target.value != 2 && e.target.value != 6 ? modelo.localAcidente.uf.valor : '' },
                pais: { ...modelo.localAcidente.pais, valor: e.target.value == 2 ? modelo.localAcidente.pais.valor : '' },
                codigoPostal: { ...modelo.localAcidente.codigoPostal, valor: e.target.value == 2 ? modelo.localAcidente.pais.valor : '' },
                especificacaoLocalAcidente: { ...modelo.localAcidente.especificacaoLocalAcidente, rotulo: e.target.value != 6 ? "Especificação do local do acidente (pátio, rampa de acesso, posto de trabalho, etc.)" : "Descreva o tipo de embarcação utilizada (jangada, lancha, navio...)" },
                numeroNaoInformado: valorNumeroLogradouro === 'S/N'
            }
        });
    }

    async function handleChangeCep(e) {
        const valorCep = e.target.value;
        let endereco;

        if (valorCep && valorCep.length == 9) {
            await get(`util/obterEnderecoPorCep/${valorCep}`, (conteudoResposta) => { endereco = conteudoResposta; });
        }

        if (!isUndefinedOrNull(endereco)) {
            // Buscar a fonte para o campo município
            let fonteDadosAutocompleteMunicipio;
            await get(`util/obterFonteDadosAutocomplete/${modelo.localAcidente.municipio.identificadorFonteDados}/${(endereco.uf && endereco.uf.length > 0) ? JSON.stringify({ UF: endereco.uf }) : null}/${endereco.codMunicipioIBGE}`, (conteudoResposta) => { fonteDadosAutocompleteMunicipio = conteudoResposta; }, undefined, { suprimirSobreposicaoMensagens: true });

            setModelo({
                ...modelo,
                localAcidente: {
                    ...modelo.localAcidente,
                    cep: { ...modelo.localAcidente.cep, valor: valorCep },
                    tipoLogradouro: { ...modelo.localAcidente.tipoLogradouro, valor: endereco.tipoLogradouro },
                    nomeLogradouro: { ...modelo.localAcidente.nomeLogradouro, valor: endereco.logradouro },
                    bairro: { ...modelo.localAcidente.bairro, valor: endereco.bairro },
                    uf: { ...modelo.localAcidente.uf, valor: endereco.uf },
                    municipio: {
                        ...modelo.localAcidente.municipio,
                        fonteDadosAutocomplete: !isUndefinedOrNull(fonteDadosAutocompleteMunicipio) ? fonteDadosAutocompleteMunicipio : {},
                        valor: endereco.codMunicipioIBGE
                    },
                    pais: { ...modelo.localAcidente.pais, valor: '' }
                }
            });
        }
        else {
            // Simples atribuição do campo CEP
            setModelo({
                ...modelo,
                localAcidente: {
                    ...modelo.localAcidente,
                    cep: { ...modelo.localAcidente.cep, valor: valorCep }
                }
            });
        }
    }

    function handleChangeNumeroNaoInformado(e) {
        // Gerência básica do valor do localAcidente.numeroNaoInformado
        // Atribuição condicional do campo localAcidente.numeroLogradouro
        setModelo({
            ...modelo,
            localAcidente: {
                ...modelo.localAcidente,
                numeroNaoInformado: e.target.checked,
                numeroLogradouro: { ...modelo.localAcidente.numeroLogradouro, valor: e.target.checked ? 'S/N' : modelo.localAcidente.numeroLogradouro.valor }
            }
        });
    }

    function handleChangeTipoInscricaoLocalAcidente(e) {
        // Limpar o número de inscrição em caso de mudança do tipo de inscrição
        setModelo({
            ...modelo,
            localAcidente: {
                ...modelo.localAcidente,
                tipoInscricao: { ...modelo.localAcidente.tipoInscricao, valor: e.target.value },
                numeroInscricao: { ...modelo.localAcidente.numeroInscricao, valor: '' }
            }
        });
    }

    function handleChangeNumeroInscricaoLocalAcidente(e) {
        setModelo({
            ...modelo,
            localAcidente: {
                ...modelo.localAcidente,
                numeroInscricao: { ...modelo.localAcidente.numeroInscricao, valor: getStringValue(e.target.value).toUpperCase() }
            }
        });
    }

    function voltarListagem() {
        navigate(`/cat/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    function stepValidado(ehValido) {
        if (ehValido) {
            dispatch(limparMensagens());
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocadosStep1 = {};
    const objetoComponentesTocadosStep2 = {};
    const objetoComponentesTocadosStep3 = {};
    const objetoComponentesTocadosStep4 = {};

    objetoComponentesTocadosStep1['tipoCat'] = false;
    objetoComponentesTocadosStep1['catOrigem'] = false;
    objetoComponentesTocadosStep1['tipoAcidente'] = false;
    objetoComponentesTocadosStep1['dataAcidente'] = false;
    objetoComponentesTocadosStep1['horaAcidente'] = false;
    objetoComponentesTocadosStep1['horasTrabalhadasAntesAcidente'] = false;
    objetoComponentesTocadosStep1['dataUltimoDiaTrabalhado'] = false;
    objetoComponentesTocadosStep1['houveAfastamentoCat'] = false;
    objetoComponentesTocadosStep1['houveObito'] = false;
    objetoComponentesTocadosStep1['dataObito'] = false;
    objetoComponentesTocadosStep1['houveComunicacaoAutoridadePolicial'] = false;
    objetoComponentesTocadosStep1['situacaoGeradoraAcidente'] = false;
    objetoComponentesTocadosStep1['catEmitidaPor'] = false;
    objetoComponentesTocadosStep2['localAcidente.tipoLocalAcidente'] = false;
    objetoComponentesTocadosStep2['localAcidente.cep'] = false;
    objetoComponentesTocadosStep2['localAcidente.tipoLogradouro'] = false;
    objetoComponentesTocadosStep2['localAcidente.nomeLogradouro'] = false;
    objetoComponentesTocadosStep2['localAcidente.numeroLogradouro'] = false;
    objetoComponentesTocadosStep2['localAcidente.uf'] = false;
    objetoComponentesTocadosStep2['localAcidente.municipio'] = false;
    objetoComponentesTocadosStep2['localAcidente.pais'] = false;
    objetoComponentesTocadosStep2['localAcidente.codigoPostal'] = false;
    objetoComponentesTocadosStep2['localAcidente.tipoInscricao'] = false;
    objetoComponentesTocadosStep2['localAcidente.numeroInscricao'] = false;
    objetoComponentesTocadosStep3['parteAtingida'] = false;
    objetoComponentesTocadosStep3['lateralidade'] = false;
    objetoComponentesTocadosStep3['agenteCausador'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.dataAtendimento'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.horaAtendimento'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.houveInternacao'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.duracaoEstimadaTratamentoEmDias'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.houveAfastamento'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.naturezaLesao'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.cid'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.nomeEmitente'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.orgaoClasse'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.numeroInscricaoOrgaoClasse'] = false;
    objetoComponentesTocadosStep4['atestadoMedico.ufOrgaoClasse'] = false;
    objetoComponentesTocadosStep4['formulario'] = false;

    const [componenteTocadoFormularioStep1, setComponenteTocadoFormularioStep1] = useState(objetoComponentesTocadosStep1);
    const [componenteTocadoFormularioStep2, setComponenteTocadoFormularioStep2] = useState(objetoComponentesTocadosStep2);
    const [componenteTocadoFormularioStep3, setComponenteTocadoFormularioStep3] = useState(objetoComponentesTocadosStep3);
    const [componenteTocadoFormularioStep4, setComponenteTocadoFormularioStep4] = useState(objetoComponentesTocadosStep4);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormularioStep1, setRegraValidacaoFormularioStep1] = useState({});
    const [regraValidacaoFormularioStep2, setRegraValidacaoFormularioStep2] = useState({});
    const [regraValidacaoFormularioStep3, setRegraValidacaoFormularioStep3] = useState({});
    const [regraValidacaoFormularioStep4, setRegraValidacaoFormularioStep4] = useState({});

    useEffect(() => {
        const objetoRegrasValidacaoStep1 = {};
        const objetoRegrasValidacaoStep2 = {};
        const objetoRegrasValidacaoStep3 = {};
        const objetoRegrasValidacaoStep4 = {};

        if (modelo != null) {
            objetoRegrasValidacaoStep1['tipoCat'] = new RegraObrigatoriedade(modelo.tipoCat.valor, componenteTocadoFormularioStep1['tipoCat']);
            objetoRegrasValidacaoStep1['catOrigem'] = new RegraObrigatoriedade(modelo.catOrigem.valor, componenteTocadoFormularioStep1['catOrigem'] && (modelo.tipoCat.valor == 2 || modelo.tipoCat.valor == 3));
            objetoRegrasValidacaoStep1['tipoAcidente'] = new RegraObrigatoriedade(modelo.tipoAcidente.valor, componenteTocadoFormularioStep1['tipoAcidente']);
            objetoRegrasValidacaoStep1['dataAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataAcidente.valor), new RegraDiaMesAno(modelo.dataAcidente.valor)], componenteTocadoFormularioStep1['dataAcidente']);
            objetoRegrasValidacaoStep1['horaAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.horaAcidente.valor, (modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && !objetoRegrasValidacaoStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrAcid))), new RegraHoraMinuto(modelo.horaAcidente.valor)], componenteTocadoFormularioStep1['horaAcidente']);
            objetoRegrasValidacaoStep1['horasTrabalhadasAntesAcidente'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.horasTrabalhadasAntesAcidente.valor, (modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && !objetoRegrasValidacaoStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrsTrabAntesAcid))), new RegraExpressaoRegular(modelo.horasTrabalhadasAntesAcidente.valor, '([0-9]{2})([:]?)([012345][0-9])')], componenteTocadoFormularioStep1['horasTrabalhadasAntesAcidente']);
            objetoRegrasValidacaoStep1['dataUltimoDiaTrabalhado'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataUltimoDiaTrabalhado.valor, !objetoRegrasValidacaoStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_ultDiaTrab), new RegraDiaMesAno(modelo.dataUltimoDiaTrabalhado.valor)], componenteTocadoFormularioStep1['dataUltimoDiaTrabalhado']);
            objetoRegrasValidacaoStep1['houveAfastamentoCat'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.houveAfastamentoCat.valor, !objetoRegrasValidacaoStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_ultDiaTrab)], componenteTocadoFormularioStep1['houveAfastamentoCat']);
            objetoRegrasValidacaoStep1['houveObito'] = new RegraObrigatoriedade(modelo.houveObito.valor, componenteTocadoFormularioStep1['houveObito']);
            objetoRegrasValidacaoStep1['dataObito'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataObito.valor), new RegraDiaMesAno(modelo.dataObito.valor)], componenteTocadoFormularioStep1['dataObito'] && modelo.houveObito.valor == 'S');
            objetoRegrasValidacaoStep1['houveComunicacaoAutoridadePolicial'] = new RegraObrigatoriedade(modelo.houveComunicacaoAutoridadePolicial.valor, componenteTocadoFormularioStep1['houveComunicacaoAutoridadePolicial']);
            objetoRegrasValidacaoStep1['situacaoGeradoraAcidente'] = new RegraObrigatoriedade(modelo.situacaoGeradoraAcidente.valor, componenteTocadoFormularioStep1['situacaoGeradoraAcidente']);
            objetoRegrasValidacaoStep1['catEmitidaPor'] = new RegraObrigatoriedade(modelo.catEmitidaPor.valor, componenteTocadoFormularioStep1['catEmitidaPor']);
            objetoRegrasValidacaoStep1.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormularioStep1);
            objetoRegrasValidacaoStep2['localAcidente.tipoLocalAcidente'] = new RegraObrigatoriedade(modelo.localAcidente.tipoLocalAcidente.valor, componenteTocadoFormularioStep2['localAcidente.tipoLocalAcidente']);
            objetoRegrasValidacaoStep2['localAcidente.cep'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.localAcidente.cep.valor, modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 5), new RegraCep(modelo.localAcidente.cep.valor)], componenteTocadoFormularioStep2['localAcidente.cep'] && modelo.localAcidente.tipoLocalAcidente.valor != 2);
            objetoRegrasValidacaoStep2['localAcidente.tipoLogradouro'] = new RegraObrigatoriedade(modelo.localAcidente.tipoLogradouro.valor, componenteTocadoFormularioStep2['localAcidente.tipoLogradouro']);
            objetoRegrasValidacaoStep2['localAcidente.nomeLogradouro'] = new RegraObrigatoriedade(modelo.localAcidente.nomeLogradouro.valor, componenteTocadoFormularioStep2['localAcidente.nomeLogradouro']);
            objetoRegrasValidacaoStep2['localAcidente.numeroLogradouro'] = new RegraObrigatoriedade(modelo.localAcidente.numeroLogradouro.valor, componenteTocadoFormularioStep2['localAcidente.numeroLogradouro'] && !modelo.localAcidente.numeroNaoInformado);
            objetoRegrasValidacaoStep2['localAcidente.uf'] = new RegraObrigatoriedade(modelo.localAcidente.uf.valor, componenteTocadoFormularioStep2['localAcidente.uf'] && modelo.localAcidente.tipoLocalAcidente.valor != 2 && (modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 4 || modelo.localAcidente.tipoLocalAcidente.valor == 5));
            objetoRegrasValidacaoStep2['localAcidente.municipio'] = new RegraObrigatoriedade(modelo.localAcidente.municipio.valor, componenteTocadoFormularioStep2['localAcidente.municipio'] && modelo.localAcidente.tipoLocalAcidente.valor != 2 && (modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 4 || modelo.localAcidente.tipoLocalAcidente.valor == 5));
            objetoRegrasValidacaoStep2['localAcidente.pais'] = new RegraObrigatoriedade(modelo.localAcidente.pais.valor, componenteTocadoFormularioStep2['localAcidente.pais'] && modelo.localAcidente.tipoLocalAcidente.valor == 2);
            objetoRegrasValidacaoStep2['localAcidente.codigoPostal'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.localAcidente.codigoPostal.valor, modelo.localAcidente.tipoLocalAcidente.valor == 2), new RegraComprimentoMinimo(modelo.localAcidente.codigoPostal.valor, 4)], componenteTocadoFormularioStep2['localAcidente.codigoPostal']);
            objetoRegrasValidacaoStep2['localAcidente.tipoInscricao'] = new RegraObrigatoriedade(modelo.localAcidente.tipoInscricao.valor, componenteTocadoFormularioStep2['localAcidente.tipoInscricao'] && ((modelo.tipoInscricaoEmpregador == 1 && (modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3)) || modelo.codCategoria.startsWith('2')));
            objetoRegrasValidacaoStep2['localAcidente.numeroInscricao'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.localAcidente.numeroInscricao.valor), new RegraCnpj(modelo.localAcidente.numeroInscricao.valor, parseInt(modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CNPJ), new RegraCaepf(modelo.localAcidente.numeroInscricao.valor, parseInt(modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CAEPF), new RegraCno(modelo.localAcidente.numeroInscricao.valor, parseInt(modelo.localAcidente.tipoInscricao.valor) === TipoInscricao.CNO)], componenteTocadoFormularioStep2['localAcidente.numeroInscricao'] && ((modelo.tipoInscricaoEmpregador == 1 && (modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3)) || modelo.codCategoria.startsWith('2')));
            objetoRegrasValidacaoStep2.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormularioStep2);
            objetoRegrasValidacaoStep3['parteAtingida'] = new RegraObrigatoriedade(modelo.parteAtingida.valor, componenteTocadoFormularioStep3['parteAtingida']);
            objetoRegrasValidacaoStep3['lateralidade'] = new RegraObrigatoriedade(modelo.lateralidade.valor, componenteTocadoFormularioStep3['lateralidade']);
            objetoRegrasValidacaoStep3['agenteCausador'] = new RegraObrigatoriedade(modelo.agenteCausador.valor, componenteTocadoFormularioStep3['agenteCausador']);
            objetoRegrasValidacaoStep3.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormularioStep3);
            objetoRegrasValidacaoStep4['atestadoMedico.dataAtendimento'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.atestadoMedico.dataAtendimento.valor), new RegraDiaMesAno(modelo.atestadoMedico.dataAtendimento.valor)], componenteTocadoFormularioStep4['atestadoMedico.dataAtendimento']);
            objetoRegrasValidacaoStep4['atestadoMedico.horaAtendimento'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.atestadoMedico.horaAtendimento.valor), new RegraHoraMinuto(modelo.atestadoMedico.horaAtendimento.valor)], componenteTocadoFormularioStep4['atestadoMedico.horaAtendimento']);
            objetoRegrasValidacaoStep4['atestadoMedico.houveInternacao'] = new RegraObrigatoriedade(modelo.atestadoMedico.houveInternacao.valor, componenteTocadoFormularioStep4['atestadoMedico.houveInternacao']);
            objetoRegrasValidacaoStep4['atestadoMedico.duracaoEstimadaTratamentoEmDias'] = new RegraObrigatoriedade(modelo.atestadoMedico.duracaoEstimadaTratamentoEmDias.valor, componenteTocadoFormularioStep4['atestadoMedico.duracaoEstimadaTratamentoEmDias']);
            objetoRegrasValidacaoStep4['atestadoMedico.houveAfastamento'] = new RegraObrigatoriedade(modelo.atestadoMedico.houveAfastamento.valor, componenteTocadoFormularioStep4['atestadoMedico.houveAfastamento'] && modelo.houveObito.valor == 'N');
            objetoRegrasValidacaoStep4['atestadoMedico.naturezaLesao'] = new RegraObrigatoriedade(modelo.atestadoMedico.naturezaLesao.valor, componenteTocadoFormularioStep4['atestadoMedico.naturezaLesao']);
            objetoRegrasValidacaoStep4['atestadoMedico.cid'] = new RegraObrigatoriedade(modelo.atestadoMedico.cid.valor, componenteTocadoFormularioStep4['atestadoMedico.cid']);
            objetoRegrasValidacaoStep4['atestadoMedico.nomeEmitente'] = new RegraObrigatoriedade(modelo.atestadoMedico.nomeEmitente.valor, componenteTocadoFormularioStep4['atestadoMedico.nomeEmitente']);
            objetoRegrasValidacaoStep4['atestadoMedico.orgaoClasse'] = new RegraObrigatoriedade(modelo.atestadoMedico.orgaoClasse.valor, componenteTocadoFormularioStep4['atestadoMedico.orgaoClasse']);
            objetoRegrasValidacaoStep4['atestadoMedico.numeroInscricaoOrgaoClasse'] = new RegraObrigatoriedade(modelo.atestadoMedico.numeroInscricaoOrgaoClasse.valor, componenteTocadoFormularioStep4['atestadoMedico.numeroInscricaoOrgaoClasse']);
            objetoRegrasValidacaoStep4['atestadoMedico.ufOrgaoClasse'] = new RegraObrigatoriedade(modelo.atestadoMedico.ufOrgaoClasse.valor, componenteTocadoFormularioStep4['atestadoMedico.ufOrgaoClasse'] && (modelo.atestadoMedico.orgaoClasse.valor == 1 || modelo.atestadoMedico.orgaoClasse.valor == 2));
            objetoRegrasValidacaoStep4.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormularioStep4);
        }

        setRegraValidacaoFormularioStep1(objetoRegrasValidacaoStep1);
        setRegraValidacaoFormularioStep2(objetoRegrasValidacaoStep2);
        setRegraValidacaoFormularioStep3(objetoRegrasValidacaoStep3);
        setRegraValidacaoFormularioStep4(objetoRegrasValidacaoStep4);
    }, [modelo, componenteTocadoFormularioStep1, componenteTocadoFormularioStep2, componenteTocadoFormularioStep3, componenteTocadoFormularioStep4]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        async function gerenciarAcaoFormularioCompletamenteValidado() {
            let valoresValidacaoFormulario = null;
            let passouPorTodosCampos = false;

            switch (activeStep) {
                case 0:
                    valoresValidacaoFormulario = Object.values(regraValidacaoFormularioStep1).filter((x) => typeof x !== 'boolean');
                    passouPorTodosCampos = regraValidacaoFormularioStep1.todosComponentesTocados;
                    break;
                case 1:
                    valoresValidacaoFormulario = Object.values(regraValidacaoFormularioStep2).filter((x) => typeof x !== 'boolean');
                    passouPorTodosCampos = regraValidacaoFormularioStep2.todosComponentesTocados;
                    break;
                case 2:
                    valoresValidacaoFormulario = Object.values(regraValidacaoFormularioStep3).filter((x) => typeof x !== 'boolean');
                    passouPorTodosCampos = regraValidacaoFormularioStep3.todosComponentesTocados;
                    break;
                case 3:
                    valoresValidacaoFormulario = Object.values(regraValidacaoFormularioStep4).filter((x) => typeof x !== 'boolean');
                    passouPorTodosCampos = regraValidacaoFormularioStep4.todosComponentesTocados;
                    break;
            }

            if (visualizacao) {
                if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'proximo') {
                    setActiveStep((prevActiveStep) => prevActiveStep + 1);
                }
                return;
            }

            if (passouPorTodosCampos) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                    if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                        // Utilizar uma cópia do modelo original para realizar as transformações necessárias antes da submissão.
                        // Essas transformações são necessárias para que o C# receba corretamente as informações do javascript (evitar erros de binding)
                        let copiaModelo = {
                            ...modelo,
                            agenteCausador: { ...modelo.agenteCausador, valor: isUndefinedOrNull(modelo.agenteCausador.valor) ? 0 : modelo.agenteCausador.valor },
                            localAcidente: {
                                ...modelo.localAcidente,
                                tipoLocalAcidente: { ...modelo.localAcidente.tipoLocalAcidente, valor: isUndefinedOrNull(modelo.localAcidente.tipoLocalAcidente.valor) ? 0 : modelo.localAcidente.tipoLocalAcidente.valor },
                                tipoInscricao: { ...modelo.localAcidente.tipoInscricao, valor: isUndefinedOrNull(modelo.localAcidente.tipoInscricao.valor) ? 0 : modelo.localAcidente.tipoInscricao.valor }
                            },
                            atestadoMedico: {
                                ...modelo.atestadoMedico,
                                horaAtendimento: { ...modelo.atestadoMedico.horaAtendimento, valor: isUndefinedOrNull(modelo.atestadoMedico.horaAtendimento.valor) ? new Date('0001-01-01T00:00:00') : modelo.atestadoMedico.horaAtendimento.valor },
                                naturezaLesao: { ...modelo.atestadoMedico.naturezaLesao, valor: isUndefinedOrNull(modelo.atestadoMedico.naturezaLesao.valor) ? 0 : modelo.atestadoMedico.naturezaLesao.valor },
                                orgaoClasse: { ...modelo.atestadoMedico.orgaoClasse, valor: isUndefinedOrNull(modelo.atestadoMedico.orgaoClasse.valor) ? 0 : modelo.atestadoMedico.orgaoClasse.valor }
                            },
                            stepAtual: activeStep
                        };

                        if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter' && !visualizacao) {
                            await post(`/sst/cat/salvar/${idContrato}/${tsv}/${admPreliminar}`, copiaModelo, voltarListagem, undefined, { mensagensResistentes: true });
                        } else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'proximo') {
                            if (visualizacao) {
                                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                            } else {
                                //console.log(copiaModelo);
                                await post("/sst/cat/validarParcial", copiaModelo, stepValidado);
                            }
                        }
                    }
                    else {
                        rolarVisualizacaoAteElementoInvalido();
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        gerenciarAcaoFormularioCompletamenteValidado();
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado,
        regraValidacaoFormularioStep1.todosComponentesTocados,
        regraValidacaoFormularioStep2.todosComponentesTocados,
        regraValidacaoFormularioStep3.todosComponentesTocados,
        regraValidacaoFormularioStep4.todosComponentesTocados]);

    // Rolar para o início do indicador de passos a cada troca de passo executada
    useEffect(() => {
        rolarVisualizacaoAteElemento('indicador-passos');
    }, [activeStep]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setComponenteTocadoFormularioStep4(obterObjetoTodosComponentesTocados(componenteTocadoFormularioStep4));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    const processamentoResposta = (conteudoResposta) => {
        //console.log(conteudoResposta);

        // Tratar os valores cuja representação em C# não seria traduzida em valor adequado para Javascript
        // Esse tratamento é importante para a aplicação correta das validações de obrigatoriedade
        setModelo({
            ...conteudoResposta,
            tipoCat: {
                ...conteudoResposta.tipoCat,
                valor: getStringValue(conteudoResposta.tipoCat.valor) === '0' ? null : conteudoResposta.tipoCat.valor
            },
            catEmitidaPor: {
                ...conteudoResposta.catEmitidaPor,
                valor: getStringValue(conteudoResposta.catEmitidaPor.valor) === '0' ? null : conteudoResposta.catEmitidaPor.valor
            },
            localAcidente: {
                ...conteudoResposta.localAcidente,
                especificacaoLocalAcidente: {
                    ...conteudoResposta.localAcidente.especificacaoLocalAcidente,
                    rotulo: "Especificação do local do acidente (pátio, rampa de acesso, posto de trabalho, etc.)"
                },
                tipoLocalAcidente: {
                    ...conteudoResposta.localAcidente.tipoLocalAcidente,
                    valor: getStringValue(conteudoResposta.localAcidente.tipoLocalAcidente.valor) === '0' ? null : conteudoResposta.localAcidente.tipoLocalAcidente.valor
                },
                tipoInscricao: {
                    ...conteudoResposta.localAcidente.tipoInscricao,
                    valor: getStringValue(conteudoResposta.localAcidente.tipoInscricao.valor) === '0' ? null : conteudoResposta.localAcidente.tipoInscricao.valor
                }
            },
            agenteCausador: {
                ...conteudoResposta.agenteCausador,
                valor: getStringValue(conteudoResposta.agenteCausador.valor) === '0' ? null : conteudoResposta.agenteCausador.valor
            },
            atestadoMedico: {
                ...conteudoResposta.atestadoMedico,
                naturezaLesao: {
                    ...conteudoResposta.atestadoMedico.naturezaLesao,
                    valor: getStringValue(conteudoResposta.atestadoMedico.naturezaLesao.valor) === '0' ? null : conteudoResposta.atestadoMedico.naturezaLesao.valor
                },
                orgaoClasse: {
                    ...conteudoResposta.atestadoMedico.orgaoClasse,
                    valor: getStringValue(conteudoResposta.atestadoMedico.orgaoClasse.valor) === '0' ? null : conteudoResposta.atestadoMedico.orgaoClasse.valor
                }
            }
        });
    };

    useEffect(() => {
        async function obterEvento() {
            await get(`sst/cat/obterEvento/${isUndefinedOrNull(idEvento) ? 0 : idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }

        obterEvento();
    }, []);

    return (
        (modelo !== null && Object.values(regraValidacaoFormularioStep1).length > 0) ?
            <Fragment>
                <TituloPagina>Comunicação de Acidente de Trabalho</TituloPagina>

                <form id="formCat" onSubmit={(e) => handleSubmit(e)}>
                    <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                        <VepTextField
                            accessor="cpf"
                            label="CPF"
                            model={modelo}
                            xs={12} md={3}
                            readOnly
                            maskPattern={Mascara.CPF}
                        />

                        <CustomTextField
                            xs={12} md={6}
                            label="Nome"
                            value={modelo.nome}
                            readOnly />

                        {(!isUndefinedOrNull(modelo.matricula.valor) && modelo.matricula.valor.length > 0) &&
                            <VepTextField
                                accessor="matricula"
                                label="Matrícula"
                                model={modelo}
                                xs={12} md={3}
                                readOnly
                            />
                        }

                        {((isUndefinedOrNull(modelo.matricula.valor) || modelo.matricula.valor.length == 0) &&
                            !isUndefinedOrNull(modelo.codigoCategoria.valor)) &&
                            <CustomTextField
                                label="Categoria"
                                value={modelo.codigoCategoria.fonteDados[modelo.codigoCategoria.valor]}
                                xs={12} md={12}
                                readOnly
                            />
                        }
                    </Fieldset>

                    <Stepper id="indicador-passos" activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {activeStep === 0 &&
                        <Fragment>
                            <Fieldset legend="Comunicação de Acidente de Trabalho" spacing={4}>
                                <VepSelect
                                    accessor="tipoCat"
                                    model={modelo}
                                    value={modelo.tipoCat.valor}
                                    onChange={(e) => handleChangeTipoCat(e)}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['tipoCat'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'tipoCat': true })}
                                />

                                <Display show={modelo.tipoCat.valor == 2 || modelo.tipoCat.valor == 3}>
                                    <VepSelect
                                        accessor="catOrigem"
                                        label="CAT de Origem"
                                        required
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={4}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep1['catOrigem'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'catOrigem': true })}
                                    />
                                </Display>

                                <VepSelect
                                    accessor="tipoAcidente"
                                    label="Tipo do Acidente"
                                    model={modelo}
                                    value={modelo.tipoAcidente.valor}
                                    onChange={(e) => handleChangeTipoAcidente(e)}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['tipoAcidente'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'tipoAcidente': true })}
                                />

                                <VepDatePicker
                                    accessor="dataAcidente"
                                    model={modelo}
                                    value={modelo.dataAcidente.valor}
                                    onChange={date => handleChangeDataAcidente(date)}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['dataAcidente'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'dataAcidente': true })}
                                />

                                <Display show={modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && !regraValidacaoFormularioStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrAcid)}>
                                    <VepTimePicker
                                        accessor="horaAcidente"
                                        label="Hora do Acidente"
                                        required
                                        readOnly={visualizacao}
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={3}
                                        {...regraValidacaoFormularioStep1['horaAcidente'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'horaAcidente': true })}
                                    />
                                </Display>

                                <VepTextField
                                    accessor="horasTrabalhadasAntesAcidente"
                                    label=" Quantidade de horas trabalhadas antes do acidente"
                                    required={modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && !regraValidacaoFormularioStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrsTrabAntesAcid)}
                                    readOnly={visualizacao}
                                    disabled={!(modelo.tipoAcidente.valor == 1 || (modelo.tipoAcidente.valor == 3 && !regraValidacaoFormularioStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_hrsTrabAntesAcid))}
                                    maskNumber={false}
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={5}
                                    maskPattern={Mascara.HHmm}
                                    placeholder="hh:mm"
                                    maxLength={5}
                                    {...regraValidacaoFormularioStep1['horasTrabalhadasAntesAcidente'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'horasTrabalhadasAntesAcidente': true })}
                                />

                                <VepDatePicker
                                    accessor="dataUltimoDiaTrabalhado"
                                    required={!regraValidacaoFormularioStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_ultDiaTrab}
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['dataUltimoDiaTrabalhado'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'dataUltimoDiaTrabalhado': true })}
                                />

                                <VepRadioGroup
                                    accessor="houveAfastamentoCat"
                                    label="Houve afastamento?"
                                    required={!regraValidacaoFormularioStep1['dataAcidente'].existeErro() && new Date(modelo.dataAcidente.valor) >= dtAcid_validacao_ultDiaTrab}
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['houveAfastamentoCat'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'houveAfastamentoCat': true })}
                                />

                                <VepRadioGroup
                                    accessor="houveObito"
                                    label="Houve óbito?"
                                    model={modelo}
                                    value={modelo.houveObito.valor}
                                    onChange={(e) => handleChangeHouveObito(e)}
                                    xs={12} md={2}
                                    readOnly={visualizacao}
                                    disabled={modelo.tipoCat.valor == 2 || modelo.tipoCat.valor == 3}
                                    {...regraValidacaoFormularioStep1['houveObito'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'houveObito': true })}
                                />

                                <Display show={modelo.houveObito.valor == 'S'}>
                                    <VepDatePicker
                                        accessor="dataObito"
                                        required
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={3}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep1['dataObito'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'dataObito': true })}
                                    />
                                </Display>

                                <VepRadioGroup
                                    accessor="houveComunicacaoAutoridadePolicial"
                                    label=" Houve comunicação à autoridade policial?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['houveComunicacaoAutoridadePolicial'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'houveComunicacaoAutoridadePolicial': true })}
                                />

                                <CustomAutocomplete
                                    md={8}
                                    options={modelo.situacaoGeradoraAcidente.fonteDadosAutocomplete}
                                    getOptionLabel={(option) => option.rotulo}
                                    value={obterOpcaoAutocompletePorValorVep(modelo.situacaoGeradoraAcidente.fonteDadosAutocomplete, modelo.situacaoGeradoraAcidente.valor)}
                                    onChange={(event, newValue) => {
                                        setModelo({ ...modelo, situacaoGeradoraAcidente: { ...modelo.situacaoGeradoraAcidente, valor: newValue != null ? newValue.valor : '' } });
                                    }}
                                    readOnly={visualizacao}
                                    inputProps={{
                                        label: 'Situação Geradora do Acidente',
                                        title: modelo.situacaoGeradoraAcidente.descricao,
                                        required: true,
                                        ...regraValidacaoFormularioStep1['situacaoGeradoraAcidente'].obterPropriedadesValidacao(),
                                        onBlur: () => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'situacaoGeradoraAcidente': true })
                                    }}
                                />

                                <VepSelect
                                    accessor="catEmitidaPor"
                                    label="CAT emitida por"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep1['catEmitidaPor'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep1({ ...componenteTocadoFormularioStep1, 'catEmitidaPor': true })}
                                />

                                <VepTextField
                                    accessor="observacao"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={4}
                                    readOnly={visualizacao}
                                />
                            </Fieldset>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                    {activeStep === 1 &&
                        <Fragment>
                            <Fieldset legend="Local do Acidente de Trabalho" spacing={4}>
                                <VepSelect
                                    accessor="localAcidente.tipoLocalAcidente"
                                    label="Tipo do Local do Acidente"
                                    model={modelo}
                                    value={modelo.localAcidente.tipoLocalAcidente.valor}
                                    onChange={(e) => handleChangeTipoLocalAcidente(e)}
                                    xs={12} md={6}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep2['localAcidente.tipoLocalAcidente'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.tipoLocalAcidente': true })}
                                />

                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 2 && modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <VepTextField
                                        accessor="localAcidente.cep"
                                        required={modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 5}
                                        readOnly={visualizacao}
                                        disabled={modelo.localAcidente.tipoLocalAcidente.valor == 2}
                                        maxLength={9}
                                        model={modelo}
                                        value={modelo.localAcidente.cep.valor}
                                        onChange={(e) => handleChangeCep(e)}
                                        xs={12} md={2}
                                        maskPattern={Mascara.CEP}
                                        {...regraValidacaoFormularioStep2['localAcidente.cep'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.cep': true })}
                                    />
                                </Display>
                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <CustomAutocomplete
                                        md={4}
                                        options={modelo.localAcidente.tipoLogradouro.fonteDadosAutocomplete}
                                        getOptionLabel={(option) => option.rotulo}
                                        value={obterOpcaoAutocompletePorValorVep(modelo.localAcidente.tipoLogradouro.fonteDadosAutocomplete, modelo.localAcidente.tipoLogradouro.valor)}
                                        onChange={(event, newValue) => {
                                            setModelo({ ...modelo, localAcidente: { ...modelo.localAcidente, tipoLogradouro: { ...modelo.localAcidente.tipoLogradouro, valor: !isUndefinedOrNull(newValue) ? newValue.valor : '' } } });
                                        }}
                                        readOnly={visualizacao}
                                        inputProps={{
                                            label: 'Tipo do Logradouro',
                                            title: modelo.localAcidente.tipoLogradouro.descricao,
                                            required: true,
                                            ...regraValidacaoFormularioStep2['localAcidente.tipoLogradouro'].obterPropriedadesValidacao(),
                                            onBlur: () => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.tipoLogradouro': true })
                                        }}
                                    />

                                    <VepTextField
                                        accessor="localAcidente.nomeLogradouro"
                                        label="Nome do Logradouro"
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={7}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep2['localAcidente.nomeLogradouro'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.nomeLogradouro': true })}
                                    />

                                    <VepTextField
                                        accessor="localAcidente.numeroLogradouro"
                                        label="Número do Logradouro"
                                        required={!modelo.localAcidente.numeroNaoInformado}
                                        readOnly={visualizacao}
                                        disabled={modelo.localAcidente.numeroNaoInformado}
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={3}
                                        {...regraValidacaoFormularioStep2['localAcidente.numeroLogradouro'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.numeroLogradouro': true })}
                                    />

                                    <Grid item style={{ flexBasis: '16.666667%' }}>
                                        <CustomCheckboxGroup md={12} readOnly={visualizacao}>
                                            <CustomCheckbox
                                                label="Número não informado"
                                                checked={modelo.localAcidente.numeroNaoInformado}
                                                onChange={(e) => handleChangeNumeroNaoInformado(e)}
                                                readOnly={visualizacao}
                                            />
                                        </CustomCheckboxGroup>
                                    </Grid>
                                </Display>

                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <VepTextField
                                        accessor="localAcidente.complemento"
                                        label="Complemento"
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={6}
                                        readOnly={visualizacao}
                                    />

                                    <VepTextField
                                        accessor="localAcidente.bairro"
                                        label="Bairro"
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={6}
                                        readOnly={visualizacao}
                                    />
                                </Display>

                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 2 && modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <VepSelect
                                        accessor="localAcidente.uf"
                                        required={modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 4 || modelo.localAcidente.tipoLocalAcidente.valor == 5}
                                        readOnly={visualizacao || (modelo.localAcidente.cep.valor && ((`${modelo.localAcidente.cep.valor}`.search('-') >= 0 && modelo.localAcidente.cep.valor.length == 9) || (`${modelo.localAcidente.cep.valor}`.search('-') < 0 && modelo.localAcidente.cep.valor.length == 8)))}
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={2}
                                        {...regraValidacaoFormularioStep2['localAcidente.uf'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.uf': true })}
                                    />
                                </Display>

                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 2 && modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <CustomAutocomplete
                                        md={6}
                                        queryUrl={`util/obterFonteDadosAutocomplete/${modelo.localAcidente.municipio.identificadorFonteDados}/${(modelo.localAcidente.uf.valor && modelo.localAcidente.uf.valor.length > 0) ? JSON.stringify({ UF: modelo.localAcidente.uf.valor }) : null}`}
                                        queryMinLength={3}
                                        getOptionLabel={(option) => option.rotulo}
                                        value={obterOpcaoAutocompletePorValorVep(modelo.localAcidente.municipio.fonteDadosAutocomplete, modelo.localAcidente.municipio.valor)}
                                        onChange={(event, newValue) => {
                                            setModelo({ ...modelo, localAcidente: { ...modelo.localAcidente, municipio: { ...modelo.localAcidente.municipio, valor: !isUndefinedOrNull(newValue) ? newValue.valor : '', fonteDadosAutocomplete: !isUndefinedOrNull(newValue) ? [newValue] : [] } } });
                                        }}
                                        readOnly={visualizacao || (modelo.localAcidente.cep.valor && ((`${modelo.localAcidente.cep.valor}`.search('-') >= 0 && modelo.localAcidente.cep.valor.length == 9) || (`${modelo.localAcidente.cep.valor}`.search('-') < 0 && modelo.localAcidente.cep.valor.length == 8)))}
                                        inputProps={{
                                            label: 'Município',
                                            title: modelo.localAcidente.municipio.descricao,
                                            required: modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3 || modelo.localAcidente.tipoLocalAcidente.valor == 4 || modelo.localAcidente.tipoLocalAcidente.valor == 5,
                                            ...regraValidacaoFormularioStep2['localAcidente.municipio'].obterPropriedadesValidacao(),
                                            onBlur: () => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.municipio': true })
                                        }}
                                    />
                                </Display>

                                {/*País*/}
                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor != 2 && modelo.localAcidente.tipoLocalAcidente.valor != 6}>
                                    <CustomTextField
                                        xs={12} md={4}
                                        label="País"
                                        value={modelo.localAcidente.pais.fonteDadosAutocomplete.filter(x => x.valor === '105')[0].rotulo}
                                        readOnly />
                                </Display>
                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor == 2}>
                                    <CustomAutocomplete
                                        md={4}
                                        options={modelo.localAcidente.pais.fonteDadosAutocomplete.filter(x => x.valor !== '105')}
                                        getOptionLabel={(option) => option.rotulo}
                                        value={obterOpcaoAutocompletePorValorVep(modelo.localAcidente.pais.fonteDadosAutocomplete, modelo.localAcidente.pais.valor)}
                                        onChange={(event, newValue) => {
                                            setModelo({ ...modelo, localAcidente: { ...modelo.localAcidente, pais: { ...modelo.localAcidente.pais, valor: newValue != null ? newValue.valor : '' } } });
                                        }}
                                        readOnly={visualizacao}
                                        inputProps={{
                                            label: 'País',
                                            title: modelo.localAcidente.pais.descricao,
                                            required: true,
                                            ...regraValidacaoFormularioStep2['localAcidente.pais'].obterPropriedadesValidacao(),
                                            onBlur: () => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.pais': true })
                                        }}
                                    />
                                </Display>

                                <Display show={modelo.localAcidente.tipoLocalAcidente.valor == 2}>
                                    <VepTextField
                                        accessor="localAcidente.codigoPostal"
                                        label="Código Postal"
                                        required
                                        model={modelo}
                                        setModel={setModelo}
                                        xs={12} md={2}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep2['localAcidente.codigoPostal'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.codigoPostal': true })}
                                    />
                                </Display>

                                <VepTextField
                                    accessor="localAcidente.especificacaoLocalAcidente"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={4}
                                    readOnly={visualizacao}
                                />
                            </Fieldset>

                            <Display show={(modelo.tipoInscricaoEmpregador == 1 && (modelo.localAcidente.tipoLocalAcidente.valor == 1 || modelo.localAcidente.tipoLocalAcidente.valor == 3)) || modelo.codCategoria.startsWith('2')}>
                                <Fieldset legend="Identificação do local onde ocorreu o acidente" spacing={4}>
                                    <VepSelect
                                        accessor="localAcidente.tipoInscricao"
                                        label="Tipo de inscrição do local onde ocorreu o acidente ou a doença ocupacional"
                                        model={modelo}
                                        value={modelo.localAcidente.tipoInscricao.valor}
                                        onChange={(e) => handleChangeTipoInscricaoLocalAcidente(e)}
                                        xs={12} md={7}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep2['localAcidente.tipoInscricao'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.tipoInscricao': true })}
                                    />

                                    <CnpjAlfanumerico
                                        accessor="localAcidente.numeroInscricao"
                                        label="Número de Inscrição"
                                        model={modelo}
                                        value={modelo.localAcidente.numeroInscricao.valor}
                                        onChange={(e) => handleChangeNumeroInscricaoLocalAcidente(e)}
                                        xs={12} md={3}
                                        maskPattern={obterMascaraPorTipoInscricao(modelo.localAcidente.tipoInscricao.valor)}
                                        maxLength={getStringValue(obterMascaraPorTipoInscricao(modelo.localAcidente.tipoInscricao.valor)).length}
                                        readOnly={visualizacao}
                                        {...regraValidacaoFormularioStep2['localAcidente.numeroInscricao'].obterPropriedadesValidacao()}
                                        onBlur={() => setComponenteTocadoFormularioStep2({ ...componenteTocadoFormularioStep2, 'localAcidente.numeroInscricao': true })}
                                    />
                                </Fieldset>
                            </Display>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                    {activeStep === 2 &&
                        <Fragment>
                            <Fieldset legend="Parte atingida pelo acidente de trabalho" spacing={4}>
                                <CustomAutocomplete
                                    md={9}
                                    options={modelo.parteAtingida.fonteDadosAutocomplete}
                                    getOptionLabel={(option) => option.rotulo}
                                    value={obterOpcaoAutocompletePorValorVep(modelo.parteAtingida.fonteDadosAutocomplete, modelo.parteAtingida.valor)}
                                    onChange={(event, newValue) => {
                                        setModelo({ ...modelo, parteAtingida: { ...modelo.parteAtingida, valor: newValue != null ? newValue.valor : '' } });
                                    }}
                                    readOnly={visualizacao}
                                    inputProps={{
                                        label: 'Parte Atingida',
                                        title: modelo.parteAtingida.descricao,
                                        required: true,
                                        ...regraValidacaoFormularioStep3['parteAtingida'].obterPropriedadesValidacao(),
                                        onBlur: () => setComponenteTocadoFormularioStep3({ ...componenteTocadoFormularioStep3, 'parteAtingida': true })
                                    }}
                                />

                                <VepSelect
                                    accessor="lateralidade"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep3['lateralidade'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep3({ ...componenteTocadoFormularioStep3, 'lateralidade': true })}
                                />
                            </Fieldset>

                            {/*Exemplo de utilização de campo Autocomplete com opções completamente carregadas (sem busca asíncrona no servidor)*/}
                            {/*Usar da mesma maneira (presença de options, value e onChange)*/}
                            <Fieldset legend="Agente causador do acidente de trabalho" spacing={4}>
                                <CustomAutocomplete
                                    md={12}
                                    options={modelo.agenteCausador.fonteDadosAutocomplete}
                                    getOptionLabel={(option) => option.rotulo}
                                    value={obterOpcaoAutocompletePorValorVep(modelo.agenteCausador.fonteDadosAutocomplete, modelo.agenteCausador.valor)}
                                    onChange={(event, newValue) => {
                                        setModelo({ ...modelo, agenteCausador: { ...modelo.agenteCausador, valor: newValue != null ? newValue.valor : '' } });
                                    }}
                                    readOnly={visualizacao}
                                    inputProps={{
                                        label: 'Agente Causador',
                                        title: modelo.agenteCausador.descricao,
                                        required: true,
                                        ...regraValidacaoFormularioStep3['agenteCausador'].obterPropriedadesValidacao(),
                                        onBlur: () => setComponenteTocadoFormularioStep3({ ...componenteTocadoFormularioStep3, 'agenteCausador': true })
                                    }}
                                />
                            </Fieldset>
                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                    {activeStep === 3 &&
                        <Fragment>
                            <Fieldset legend="Atestado Médico" spacing={4}>
                                <VepDatePicker
                                    accessor="atestadoMedico.dataAtendimento"
                                    label="Data do Atendimento"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.dataAtendimento'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.dataAtendimento': true })}
                                />

                                <VepTimePicker
                                    accessor="atestadoMedico.horaAtendimento"
                                    label="Hora do Atendimento"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.horaAtendimento'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.horaAtendimento': true })}
                                />

                                <VepRadioGroup
                                    accessor="atestadoMedico.houveInternacao"
                                    label="Houve internação?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={2}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.houveInternacao'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.houveInternacao': true })}
                                />

                                <VepTextField
                                    accessor="atestadoMedico.duracaoEstimadaTratamentoEmDias"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.duracaoEstimadaTratamentoEmDias'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.duracaoEstimadaTratamentoEmDias': true })}
                                />

                                <VepRadioGroup
                                    accessor="atestadoMedico.houveAfastamento"
                                    label="Houve afastamento durante o tratamento?"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={4}
                                    readOnly={visualizacao}
                                    disabled={modelo.houveObito.valor == 'S'}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.houveAfastamento'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.houveAfastamento': true })}
                                />

                                <CustomAutocomplete
                                    md={8}
                                    options={modelo.atestadoMedico.naturezaLesao.fonteDadosAutocomplete}
                                    getOptionLabel={(option) => option.rotulo}
                                    value={obterOpcaoAutocompletePorValorVep(modelo.atestadoMedico.naturezaLesao.fonteDadosAutocomplete, modelo.atestadoMedico.naturezaLesao.valor)}
                                    onChange={(event, newValue) => {
                                        setModelo({ ...modelo, atestadoMedico: { ...modelo.atestadoMedico, naturezaLesao: { ...modelo.atestadoMedico.naturezaLesao, valor: newValue != null ? newValue.valor : '' } } });
                                    }}
                                    readOnly={visualizacao}
                                    inputProps={{
                                        label: 'Natureza da Lesão',
                                        title: modelo.atestadoMedico.naturezaLesao.descricao,
                                        required: true,
                                        ...regraValidacaoFormularioStep4['atestadoMedico.naturezaLesao'].obterPropriedadesValidacao(),
                                        onBlur: () => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.naturezaLesao': true })
                                    }}
                                />

                                <VepTextField
                                    accessor="atestadoMedico.descricaoComplementarLesao"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={2}
                                    readOnly={visualizacao}
                                />

                                <VepTextField
                                    accessor="atestadoMedico.diagnosticoProvavel"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={2}
                                    readOnly={visualizacao}
                                />

                                {/*Exemplo de utilização de campo Autocomplete com busca assíncrona dos dados no servidor*/}
                                {/*Usar da mesma maneira (presença de queryUrl, value e onChange, sendo que, neste último, a fonte de dados do autocomplete também é atualizada)*/}
                                <CustomAutocomplete
                                    md={12}
                                    queryUrl={`util/obterFonteDadosAutocomplete/${modelo.atestadoMedico.cid.identificadorFonteDados}/${null}`}
                                    queryMinLength={3}
                                    getOptionLabel={(option) => option.rotulo}
                                    value={obterOpcaoAutocompletePorValorVep(modelo.atestadoMedico.cid.fonteDadosAutocomplete, modelo.atestadoMedico.cid.valor)}
                                    onChange={(event, newValue) => {
                                        setModelo({ ...modelo, atestadoMedico: { ...modelo.atestadoMedico, cid: { ...modelo.atestadoMedico.cid, valor: !isUndefinedOrNull(newValue) ? newValue.valor : '', fonteDadosAutocomplete: !isUndefinedOrNull(newValue) ? [newValue] : [] } } });
                                    }}
                                    readOnly={visualizacao}
                                    inputProps={{
                                        label: modelo.atestadoMedico.cid.rotulo,
                                        title: modelo.atestadoMedico.cid.descricao,
                                        required: true,
                                        ...regraValidacaoFormularioStep4['atestadoMedico.cid'].obterPropriedadesValidacao(),
                                        onBlur: () => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.cid': true })
                                    }}
                                />

                                <VepTextField
                                    accessor="atestadoMedico.observacao"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={12}
                                    multiline
                                    rows={2}
                                    readOnly={visualizacao}
                                />
                            </Fieldset>

                            <Fieldset legend="Médico ou dentista que emitiu o atestado" spacing={4}>
                                <VepTextField
                                    accessor="atestadoMedico.nomeEmitente"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={7}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.nomeEmitente'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.nomeEmitente': true })}
                                />

                                <VepSelect
                                    accessor="atestadoMedico.orgaoClasse"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={5}
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.orgaoClasse'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.orgaoClasse': true })}
                                />

                                <VepTextField
                                    accessor="atestadoMedico.numeroInscricaoOrgaoClasse"
                                    label="Número do órgão de classe ou  Registro do Ministério da Saúde (RMS)"
                                    title={modelo.atestadoMedico.numeroInscricaoOrgaoClasse.descricao}
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={7}
                                    readOnly={visualizacao}
                                    required
                                    {...regraValidacaoFormularioStep4['atestadoMedico.numeroInscricaoOrgaoClasse'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.numeroInscricaoOrgaoClasse': true })}
                                />

                                <VepSelect
                                    accessor="atestadoMedico.ufOrgaoClasse"
                                    model={modelo}
                                    setModel={setModelo}
                                    xs={12} md={3}
                                    required={modelo.atestadoMedico.orgaoClasse.valor == 1 || modelo.atestadoMedico.orgaoClasse.valor == 2}
                                    emptyOption
                                    readOnly={visualizacao}
                                    {...regraValidacaoFormularioStep4['atestadoMedico.ufOrgaoClasse'].obterPropriedadesValidacao()}
                                    onBlur={() => setComponenteTocadoFormularioStep4({ ...componenteTocadoFormularioStep4, 'atestadoMedico.ufOrgaoClasse': true })}
                                />
                            </Fieldset>

                            {getStepperButtons(visualizacao)}
                        </Fragment>
                    }
                </form>
            </Fragment> :
            <ContentPreview />
    );
}

export default CatRegistro;